export default function FrameReturnTop({ visible, onClick }) {
  if (!visible) return null;
  return (
    <button type="button" className="frame-return-top" onClick={onClick} aria-label="Return to top of this frame">
      Top
    </button>
  );
}
